import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

export const DASHBOARD_BULK_ACTION_REQUIRED_ONE_OF_FEATURES = [
    RbacFeature.dashboardPauseEntity,
    RbacFeature.dashboardActivateDeactivateEntity,
    RbacFeature.dashboardCreateNewLink,
];
